if (!customElements.get('adev-human-readable-time')) {
    customElements.define('adev-human-readable-time', class adevHumanReadableTime extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const data = this.dataset.date; // format: DD/MM/YYYY HH:mm
            if (!data) return;

            // Parse date string
            const [datePart, timePart] = data.split(' ');
            const [day, month, year] = datePart.split('/').map(Number);
            const [hour, minute] = timePart.split(':').map(Number);

            const dateObj = new Date(year, month - 1, day, hour, minute);
            const now = new Date();
            const diffMs = now - dateObj;
            const diffMins = Math.floor(diffMs / 60000);
            const diffHours = Math.floor(diffMins / 60);
            const diffDays = Math.floor(diffHours / 24);

            let text = '';
            if (diffMins < 1) {
                text = 'just now';
            } else if (diffMins < 60) {
                text = `${diffMins} min${diffMins === 1 ? '' : 's'} ago`;
            } else if (diffHours < 24) {
                text = `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
            } else {
                text = `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;
            }

            this.textContent = text;
        }
    })
}


if (!customElements.get('adev-tabs')) {
    customElements.define('adev-tabs', class adevTabs extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-tab="toggle"]').forEach(button => {
                button.addEventListener('click', () => {
                    const id = button.dataset.id;
                    const tab = this.querySelector(`[data-adev-tab="tab"][data-id="${id}"]`);

                    if (!tab) return;

                    if (tab.classList.contains('active')) {
                        tab.classList.remove('active');
						button.classList.remove('active');
                        return;
                    }

					this.querySelectorAll('[data-adev-tab="toggle"].active').forEach(tab => {
						tab.classList.remove('active');
					});

                    this.querySelectorAll('[data-adev-tab="tab"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

					button.classList.add('active');
                    tab.classList.add('active');

                });
            });

            this.querySelectorAll('[data-adev-tab="open"]').forEach(button => {
                button.addEventListener('click', () => {
                    const id = button.dataset.id;
                    const tab = this.querySelector(`[data-adev-tab="tab"][data-id="${id}"]`);

                    if (!tab) return;

                    this.querySelectorAll('[data-adev-tab="open"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

                    this.querySelectorAll('[data-adev-tab="tab"].active').forEach(tab => {
                        tab.classList.remove('active');
                    });

					button.classList.add('active');
                    tab.classList.add('active');

                });
            });
        }

    })
}


if (!customElements.get('adev-video-tag')) {
	customElements.define('adev-video-tag', class adevVideoTag extends HTMLElement {
		constructor() {
			super();

			this.autoplay = this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay') === 'true';

			const observer = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						if(this.autoplay) {
							this.togglePlay();
						} else {
							this.initVideo();
						}

						observer.unobserve(this);
					}
				});
			});

			observer.observe(this);
			
		}

		initVideo(){
			this.video = this.querySelector('video');

			if(!this.video) {
				const scriptEl = this.querySelector('script');

				this.innerHTML += scriptEl.innerHTML;
				this.video = this.querySelector('video');

				this.setVideoEventListeners();
			}
		}

		togglePlay(){
			this.initVideo();

			if (this.video.paused) {
				this.video.play();
			} else {
				this.video.pause();
			}
		}

		play(){
			this.initVideo();
			this.video.play();
		}

		pause(){
			this.initVideo();
			this.video.pause();
		}

		mute(){
			this.initVideo();
			this.video.muted = true;
		}

		unmute(){
			this.initVideo();
			this.video.muted = false;
		}

		toggleMute() {
			this.initVideo();

			if (this.video.muted) {
				this.video.muted = false;
			} else {
				this.video.muted = true;
			}
		}

		setVideoEventListeners(){
			this._onVideoMuted();

			this.video.addEventListener('play', this._onVideoPlay.bind(this));
			this.video.addEventListener('pause', this._onVideoPause.bind(this));
			this.video.addEventListener('volumechange', this._onVideoMuted.bind(this));

			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			playButton.addEventListener('click', this.togglePlay.bind(this));

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			if (toggleMuteButton) {
				toggleMuteButton.addEventListener('click', this.toggleMute.bind(this));
			}
		}

		_onVideoPlay() {
			this.classList.add('adev--is-revealed');
			this.classList.add('adev--is-playing');
		}

		_onVideoPause() {
			this.classList.remove('adev--is-playing');
		}

		_onVideoMuted() {
			if (this.video.muted) {
				this.classList.add('adev--is-muted');
			} else {
				this.classList.remove('adev--is-muted');
			}
		}

		connectedCallback() {
		}

		disconnectedCallback() {
			const playButton = this.querySelector('[data-adev-video-tag="play"]');
			playButton.removeEventListener('click', this.togglePlay.bind(this));

			const toggleMuteButton = this.querySelector('[data-adev-video-tag="mute"]');
			if (toggleMuteButton) {
				toggleMuteButton.removeEventListener('click', this.toggleMute.bind(this));
			}

			if (this.video) {
				this.video.removeEventListener('play', this._onVideoPlay.bind(this));
				this.video.removeEventListener('pause', this._onVideoPause.bind(this));
				this.video.removeEventListener('volumechange', this._onVideoMuted.bind(this));
			}
		}

	});
}